import React from 'react';
import './billing.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';

const Index = () => {
  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Facturación'></ToolbarSimple>
    </ScrollView>
  );
};

export default Index;
